(() => {
  window.park.app({
    container: 'login-tooltip',
    component: 'login-tooltip',
  });
})();



// WEBPACK FOOTER //
// ./src/widgets/login-tooltip/login-tooltip.js